import type { ColumnDef } from '@/components/ui';
import { DataTable, ErrorBanner, PageHeader, PageLoading } from '@/components/ui';
import { useApi } from '@/hooks/useApi';
import { sonarqubeApi } from '@/services/sonarqube-api';
import type { ISonarqubeProjectQualityLatest } from '@skystone/shared';
import { buildRawColumns, buildStandardEmptyMessage, buildStandardTblSubtitle } from '@/lib/tbl-page-utils';
import { PageContainer } from '@/components/layout';

const sonarqubeQualityLatestColumns: ColumnDef<ISonarqubeProjectQualityLatest>[] = buildRawColumns<ISonarqubeProjectQualityLatest>([
  { key: 'id', header: 'ID' },
  { key: 'projectKey', header: 'Project Key' },
  { key: 'ingestionDate', header: 'Ingestion Date' },
  { key: 'runId', header: 'Run ID' },
  { key: 'coveragePct', header: 'Coverage Pct' },
  { key: 'reliabilityScore', header: 'Reliability Score' },
  { key: 'reliabilityGrade', header: 'Reliability Grade' },
  { key: 'maintainabilityScore', header: 'Maintainability Score' },
  { key: 'maintainabilityGrade', header: 'Maintainability Grade' },
  { key: 'lastAnalysisAt', header: 'Last Analysis At' },
  { key: 'qualityStatus', header: 'Quality Status' },
  { key: 'fabricSynced', header: 'Fabric Synced' },
  { key: 'fabricSyncedAt', header: 'Fabric Synced At' },
  { key: 'createdAt', header: 'Created At' },
  { key: 'updatedAt', header: 'Updated At' },
]);

export function TblSonarqubeQualityLatestPage() {
  const { data: rows, loading, error } = useApi(() => sonarqubeApi.getQualityLatest({ limit: 500 }), []);

  if (loading && !rows) return <PageLoading />;

  return (
    <PageContainer variant="wide" className="space-y-6">
      <PageHeader title="Tbl - raw_fact_sonarqube_project_quality_latest" subtitle={buildStandardTblSubtitle()} />
      <ErrorBanner message={error} />
      <DataTable
        data={rows ?? []}
        columns={sonarqubeQualityLatestColumns}
        keyExtractor={(row) => row.id}
        enablePagination
        enableFilters
        emptyMessage={buildStandardEmptyMessage('sonarqube quality latest')}
      />
    </PageContainer>
  );
}
